module.exports = __webpack_public_path__ + "static/media/p2.9731a3f0.svg";